import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import {TransportModeService} from "../service/TransportModeService";
import {useMountEffect} from "primereact";
import {isNullOrUndef} from "chart.js/helpers";

export const TransportMode = () => {

    let emptyTransportMode = {
        id: null,
        name: ''
    };

    const [transportModes, setTransportModes] = useState(null);
    const [transportModeDialog, setTransportModeDialog] = useState(false);
    const [deleteTransportModeDialog, setDeleteTransportModeDialog] = useState(false);
    const [transportMode, setTransportMode] = useState(emptyTransportMode);
    const [selectedTransportMode, setSelectedTransportMode] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);
    const [loading, setLoading] = useState(true);
    const transportModeService = new TransportModeService();


    useMountEffect(() => {
        transportModeService.getTransportModes()
            .then(data => {
                setTransportModes(data);
                setLoading(false);
            });
    });

    const openNew = () => {
        setTransportMode(emptyTransportMode);
        setSubmitted(false);
        setTransportModeDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setTransportModeDialog(false);
    }

    const hideDeleteTransportModeDialog = () => {
        setDeleteTransportModeDialog(false);
    }

    const saveTransportMode = () => {
        setSubmitted(true);

        if (transportMode.name.trim()) {
            let _transportModes = [...transportModes];
            let _transportMode = {...transportMode};

            transportModeService.saveTransportMode(_transportMode)
                .then(data => {
                    if (transportMode.id) {
                        const index = findIndexById(transportMode.id);
                        _transportModes[index] = data;
                        toast.current.show({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Transport mode Updated',
                            life: 3000
                        });
                    } else {
                        _transportModes.push(data);
                        toast.current.show({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Transport mode Created',
                            life: 3000
                        });
                    }
                    setTransportModes(_transportModes);
                    setTransportModeDialog(false);
                    setTransportMode(emptyTransportMode);
                })
                .catch(error => {
                    toast.current.show({severity: 'error', summary: 'Error', detail: error, life: 3000});
                });
        }
    }

    const editTransportMode = (transportMode) => {
        setTransportMode({ ...transportMode });
        setTransportModeDialog(true);
    }

    const confirmDeleteTransportMode = (transportMode) => {
        setTransportMode(transportMode);
        setDeleteTransportModeDialog(true);
    }

    const deleteTransportMode = () => {
        transportModeService.deleteTransportMode(transportMode.id)
            .then(data => {
                if(!isNullOrUndef(data) && !data.success) {
                    setDeleteTransportModeDialog(false);
                    setTransportMode(emptyTransportMode);
                    toast.current.show({severity: 'error', summary: 'Error', detail: data.errorMessage, life: 3000});
                } else {
                    let _transportModes = transportModes.filter(val => val.id !== transportMode.id);
                    setTransportModes(_transportModes);
                    setDeleteTransportModeDialog(false);
                    setTransportMode(emptyTransportMode);
                    toast.current.show({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'TransportMode Deleted',
                        life: 3000
                    });
                }
            })
            .catch(error => {
                toast.current.show({severity: 'error', summary: 'Error', detail: error, life: 3000});
            });
    }

    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < transportModes.length; i++) {
            if (transportModes[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _transportMode = { ...transportMode };
        _transportMode[`${name}`] = val;

        setTransportMode(_transportMode);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2 p-mb-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const titleBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Title</span>
                {rowData.name}
            </>
        );
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text p-button-sm"
                        title={'Edit'} onClick={() => editTransportMode(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-text p-button-sm"
                        title={'Delete'} onClick={() => confirmDeleteTransportMode(rowData)} />
            </div>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="p-m-0">Transport modes</h5>
        </div>
    );

    const TransportModeDialogFooter = (
        <>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveTransportMode} />
        </>
    );
    const deleteTransportModeDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteTransportModeDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteTransportMode} />
        </>
    );

    return (
        <div className="p-grid crud-demo">
            <div className="p-col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="p-mb-4 p-toolbar" left={leftToolbarTemplate}/>

                    <DataTable ref={dt} value={transportModes} selection={selectedTransportMode} onSelectionChange={(e) => setSelectedTransportMode(e.value)}
                               dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive" loading={loading}
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} transport mode"
                               emptyMessage="No transport mode found." header={header}>
                        <Column field="name" header="Title" sortable body={titleBodyTemplate}/>
                        <Column body={actionBodyTemplate} bodyStyle={{textAlign: 'right'}}/>
                    </DataTable>

                    <Dialog visible={transportModeDialog} style={{ width: '450px' }} header="TransportMode Details" modal className="p-fluid" footer={TransportModeDialogFooter} onHide={hideDialog}>
                        <div className="p-field">
                            <label htmlFor="title">Title</label>
                            <InputText id="title" value={transportMode.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !transportMode.name })} />
                            {submitted && !transportMode.name && <small className="p-invalid">Name is required.</small>}
                        </div>
                    </Dialog>

                    <Dialog visible={deleteTransportModeDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteTransportModeDialogFooter} onHide={hideDeleteTransportModeDialog}>
                        <div className="confirmation-content">
                            <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                            {transportMode && <span>Are you sure you want to delete <b>{transportMode.name}</b>?</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    );
}
